"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var reducers = {
    globalMessage: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_GLOBAL_MESSAGE] = function (state, action) { return action.payload; },
        _a), null),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map